var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content example-md-doc"},[_c('div',{staticClass:"tip"},[_c('p',[_vm._v("1、你可以像 excle 那样，选中单元格并批量的复制、粘贴、剪切、删除操作")])])])}]

export { render, staticRenderFns }